// @flow
import React, { Component } from "react";

import UserAuth from "../../global/containers/UserAuth";
import RedirectoLogin from "./RedirectoLogin";
import PeopleDrawer from "../containers/people/PeopleDrawer";

class People extends Component<*> {
  constructor(props) {
    super(props);
  }

  render(): * {
    return (
      <UserAuth principal='online-user' unAuthChildren={<RedirectoLogin />} >
        <div className="app-main">
          <PeopleDrawer />
        </div>
      </UserAuth>
    );
  }
}

export default People;